var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.8 29.5l-1.2 1-0.5 0.4-0.7 0.5-0.4 0.3-0.5 0.3-0.4 0.2-0.3 0.2c-0.1 0-0.1 0.1-0.1 0.1l-0.3 0.2-0.2 0.1c-0.4 0.2-0.7 0.3-0.9 0.2-1.4-0.3-4.8-2.5-7.9-5.6-1.6-1.6-2.9-3.2-3.9-4.7l-0.4-0.6c-0.7-1.1-1.1-2.1-1.3-2.7v-0.4l0.1-0.2v-0.1l0.1-0.2 0.1-0.2 0.2-0.3 0.2-0.3 0.2-0.3 0.3-0.4 0.3-0.4 0.3-0.4 0.4-0.5 0.6-0.8 0.7-0.9-8.1-13.9-0.8 0.2c-2.1 0.4-4.8 1.8-6.6 3.8-2.5 2.7-3.3 6.3-1.5 10.4 3.3 8 7.1 13.5 12.8 19.3 6 6 11.6 9.8 19.3 12.8 4 1.6 7.6 0.9 10.3-1.6 2-1.8 3.5-4.5 3.8-6.5l0.2-0.8-13.9-8.2zm11.1 9.5c-1.2 4.1-5.5 7.4-10.7 5.3-7.4-2.9-12.8-6.6-18.5-12.3-5.6-5.6-9.1-10.8-12.3-18.5-1.3-3.2-0.8-5.8 1.1-7.8 1.2-1.3 2.9-2.3 4.4-2.8h0.1l6.4 10.9-0.5 0.6-0.4 0.6c-0.1 0.1-0.1 0.2-0.2 0.3l-0.4 0.5c-1.3 1.9-1.7 2.9-1.4 4.2 0.4 2.1 2.8 5.9 6.1 9.2 3.4 3.4 7.2 5.8 9.1 6.2h0.1c1.1 0.2 2-0.1 3.6-1.2l0.5-0.3 0.5-0.4 0.6-0.4 0.6-0.5c0.1-0.1 0.2-0.2 0.3-0.2l11 6.5v0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1630b4773dbb1ce1373b9c81f4a49125.svg";
export { ForwardRef as ReactComponent };